"use client"

import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react"
import { CheckIcon } from "@chakra-ui/icons"
import PropTypes from "prop-types"

export default function ArrowStepper({ steps, activeIndex, onStepClick }) {
  const activeBg = useColorModeValue("blue.500", "blue.400")
  const completedBg = useColorModeValue("green.500", "green.400")
  const inactiveBg = useColorModeValue("gray.200", "gray.600")
  const activeText = useColorModeValue("white", "white")
  const completedText = useColorModeValue("white", "white")
  const inactiveText = useColorModeValue("gray.500", "gray.400")
  const connectorBg = useColorModeValue("gray.200", "gray.600")
  const activeConnectorBg = useColorModeValue("blue.500", "blue.400")
  const gray800 = useColorModeValue("gray.800", "white")

  return (
    <Flex align="center" justify="space-between" w="full">
      {steps.map((step, index) => {
        const isActive = index === activeIndex
        const isCompleted = index < activeIndex
        const isClickable = onStepClick && (index <= activeIndex || isCompleted)

        return (
          <Flex key={index} align="center" flex={index < steps.length - 1 ? 1 : "none"}>
            {/* Step Circle */}
            <Flex
              align="center"
              justify="center"
              w={10}
              h={10}
              borderRadius="full"
              bg={isCompleted ? completedBg : isActive ? activeBg : inactiveBg}
              color={isCompleted ? completedText : isActive ? activeText : inactiveText}
              cursor={isClickable ? "pointer" : "default"}
              onClick={isClickable ? () => onStepClick(index) : undefined}
              transition="all 0.2s"
              _hover={isClickable ? { transform: "scale(1.05)" } : {}}
              position="relative"
            >
              {isCompleted ? (
                <CheckIcon boxSize={4} />
              ) : (
                <Text fontSize="sm" fontWeight="bold">
                  {index + 1}
                </Text>
              )}
            </Flex>

            {/* Step Label */}
            <Box ml={3} minW="0">
              <Text
                fontSize="sm"
                fontWeight={isActive ? "600" : "500"}
                color={isCompleted || isActive ? gray800 : inactiveText}
                cursor={isClickable ? "pointer" : "default"}
                onClick={isClickable ? () => onStepClick(index) : undefined}
                transition="all 0.2s"
                _hover={isClickable ? { color: activeBg } : {}}
                noOfLines={1}
              >
                {step}
              </Text>
            </Box>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <Box
                flex={1}
                h="2px"
                mx={4}
                bg={index < activeIndex ? activeConnectorBg : connectorBg}
                borderRadius="full"
                transition="all 0.3s"
              />
            )}
          </Flex>
        )
      })}
    </Flex>
  )
}

ArrowStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeIndex: PropTypes.number.isRequired,
  onStepClick: PropTypes.func,
}
